// extracted by mini-css-extract-plugin
export default {"root":"AddToCartConfirmation_root__T33Ot textSmall","checkmark":"AddToCartConfirmation_checkmark__InVKC","link":"AddToCartConfirmation_link__DTD58"};